{
  "uigWishList": {
    "itemPrice": "Ink Price",
    "errors": {
      "notListed": "it artikel is helaas niet te bestellen en wordt daarom niet geaccepteerd in het verlanglijst."
    }
  }
}
